import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import { ensureOrgConfig } from '../org-config';

// Market / Purchases are out of MVP scope: every market route bounces home unless the
// deployment opts in with MARKET_ENABLED. If the config can't load, stay closed.
export const requireMarketEnabled = async ({ context }: { context: { queryClient: QueryClient } }) => {
  const config = await ensureOrgConfig(context.queryClient).catch(() => null);
  if (!config?.marketEnabled) throw redirect({ to: '/home' });
};
